<template>
  <div class="grid-container sm:justify-center">
    <Head title="Contacto" />
    <div
      class="flex flex-col justify-center gap-4 w-full p-6 rounded-2xl border border-outline/16 mt-6 md:mt-14 sm:col-[4_/_-4] md:col-[5_/_-5] xl:col-[4_/_-4]"
    >
      <header>
        <h1 class="pb-2 headline-md md:headline-lg">Contáctanos</h1>
      </header>
      <div id="hs_form" v-once></div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'

export default {
  name: 'Contact',
  layout: Layout,
  components: { Head },
  mounted() {
    // Create script element
    let $script = document.createElement('script')
    // Add src attribute
    $script.src = '//js.hsforms.net/forms/v2.js'
    $script.type = 'text/javascript'

    document.body.appendChild($script)

    // Listen to when the script has loaded
    $script.addEventListener('load', () => {
      // Check if hbspt has been loaded
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '2935947',
          formId: '804e7413-cfec-4e26-acb6-eadf8b190411',
          target: '#hs_form',
        })
      }
    })
  },
}
</script>
